import "./Components/Story/StoryTrigger.css";
import React from "react";
import ReactDOM from "react-dom/client";
import PortalRoot from "./PortalRoot";
import "@fontsource-variable/inter/wght.css";
import "@fontsource-variable/manrope/wght.css";
import "./index.css";
import "./theme.css";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import { configureConsoleLog } from "./utils/consoleControl";
import { logPortalEnvironmentDebug } from "./utils/environmentMode";
import {
  recordPerformanceWebVital,
  startProductionPerformanceMonitoring,
} from "./utils/performanceMonitoring";

configureConsoleLog();
logPortalEnvironmentDebug();
const performanceMonitoringStarted = startProductionPerformanceMonitoring();

document.documentElement.dataset.webVitalCls = "0";
document.documentElement.dataset.ecotourViewport = `${window.innerWidth}x${window.innerHeight}`;

const container = document.getElementById("root");
let bootstrap = null;
if (container.dataset.homeRendered === "true") {
  try { bootstrap = JSON.parse(document.getElementById("ecotour-home-bootstrap").textContent); } catch { /* Normal client rendering remains the rollback path. */ }
}
const application = <PortalRoot store={store} bootstrap={bootstrap} />;
if (bootstrap?.rendered) ReactDOM.hydrateRoot(container, application);
else ReactDOM.createRoot(container).render(application);

const recordWebVital = (metric) => {
  const name = String(metric?.name || "").trim().toLowerCase();
  const value = Number(metric?.value);
  if (!name || !Number.isFinite(value)) return;

  document.documentElement.setAttribute(`data-web-vital-${name}`, String(value));
  window.dispatchEvent(new CustomEvent("ecotour:telemetry", {
    detail: {
      event: "web_vital",
      metric: name,
      value,
      rating: metric?.rating || "",
      delta: Number(metric?.delta) || 0,
      id: metric?.id || "",
    },
  }));
  recordPerformanceWebVital(metric);
};

if (performanceMonitoringStarted) reportWebVitals(recordWebVital);

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) =>
        Promise.all(
          registrations.map((registration) => registration.unregister().catch(() => false))
        )
      )
      .catch(() => {});
  });
}
